import useFirstVisible from 'src/hooks/useFirstVisible';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

const MenuCategorySelector = ({ setActiveCategory, isCategoryUpdateDisabled }) => {
    const firstVisible = useFirstVisible('menuPositions', 'categoryid', 150);

    useEffect(() => {
        if (firstVisible && firstVisible.categoryId && !isCategoryUpdateDisabled) {
            setActiveCategory(firstVisible.categoryId);
        }
    }, [firstVisible]);

    return null;
};

MenuCategorySelector.propTypes = {
    setActiveCategory: PropTypes.func.isRequired,
    isCategoryUpdateDisabled: PropTypes.bool.isRequired
};

export default MenuCategorySelector;
